import { InfoMeetingAttendeeDoNotForward } from 'owa-locstrings/lib/strings/infomeetingattendeedonotforward.locstring.json';
import loc from 'owa-localize';
import MeetingMessage from 'owa-service/lib/contract/MeetingMessage';
import MeetingRequestMessageType from 'owa-service/lib/contract/MeetingRequestMessageType';

/**
 * Returns all the infobar messages to show in the infobar
 */
export default function createDoNotForwardMeetingMessageInfoBarMessage(
    message: MeetingMessage
): string[] {
    const meetingRequestMessage = message as MeetingRequestMessageType;

    if (meetingRequestMessage?.DoNotForwardMeeting) {
        return [loc(InfoMeetingAttendeeDoNotForward)];
    } else {
        return [];
    }
}
